import {
  BulletComponent,
  EducationalScreenV2,
  ItemType,
  Typenames,
} from '@varo/graphql-schema-types';
import backgroundTextureSeafoam from 'assets/images/vxl/component/productIntroScreen/background-texture-seafoam.png';
import { useRouter } from 'expo-router';
import useRequestContactPermission from 'features/v2a/sender/hooks/useRequestContactPermission';
import React from 'react';
import { ImageSourcePropType, StyleSheet, View } from 'react-native';
import ContentList from 'shared/components/vxl/ContentList/ContentList';
import { isWeb } from 'shared/constants/platform';
import { usePressableAnalytics } from 'shared/hooks/analytics/usePressableAnalytics';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import ProductIntroScreen from 'shared/patterns/vxl/ProductIntroScreen/ProductIntroScreen';
import theme from 'shared/styles/theme';
import { Maybe } from 'shared/utils/types';

interface Props {
  screenContent?: Maybe<EducationalScreenV2>;
}

const EducationScreen = ({ screenContent }: Props) => {
  const router = useRouter();
  const { requestPermission } = useRequestContactPermission();
  const handleOnPress = async () => {
    if (!isWeb) {
      const status = await requestPermission();
      const hasPermission = status === 'granted';

      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      hasPermission ? contactsAllowedEvent() : contactsDisallowedEvent();
    }
    router.replace('/move-money/v2a/transfer');
  };

  useViewDidFocusScreenAnalyticsEvent({
    key: 'V2aEducationScreen',
  });

  const contactsAllowedEvent = usePressableAnalytics({
    analyticsId: 'contactsAccessAllowed',
  });

  const contactsDisallowedEvent = usePressableAnalytics({
    analyticsId: 'contactsAccessDisallowed',
  });

  const firstText: string =
    screenContent?.body[0]?.__typename === Typenames.TextComponent
      ? screenContent.body[0].copy
      : '';
  const secondText: string =
    screenContent?.body[1]?.__typename === Typenames.TextComponent
      ? screenContent.body[1].copy
      : '';

  const bulletItems =
    screenContent?.body[2]?.__typename === Typenames.BulletComponent
      ? (screenContent.body[2] as BulletComponent).items
      : [];

  const buttonText: string = screenContent?.footer[0]?.buttonText ?? '';

  return (
    <ProductIntroScreen
      backgroundTexture={backgroundTextureSeafoam as ImageSourcePropType}
      visual="SEND_MONEY_ANYONE_A_ANIMATED"
      visualAccessibilityLabel="Varo to anyone animation"
      topPadding={80}
      eyebrowText={firstText}
      headlineText={secondText}
      headlineTextStyle="title"
      headlineTextAlign="center"
      bodyContent={
        <View style={styles.educationBody}>
          <ContentList contentList={bulletItems} itemType={ItemType.Number} />
        </View>
      }
      primaryButton={{
        label: buttonText,
        onPress: handleOnPress,
        analyticsId: 'educationScreenButton',
        customAttributes: { source_name: 'v2a_access_prescreen' },
      }}
    />
  );
};

const styles = StyleSheet.create({
  educationBody: {
    backgroundColor: theme.color.background.primary,
    paddingHorizontal: theme.spacing.m,
  },
});

export default EducationScreen;
